export default {
  modals: {
    delete_payment_method: {
      title: 'Tem a certeza de que pretende remover este método de pagamento?',
    },
  },
  buttons: {
    confirm: 'Confirmar',
    cancel: 'Cancelar',
  },
  toasts: {
    failed_to_delete_payment_method: 'Falha ao eliminar o método de pagamento',
    payment_method_deleted: 'Método de pagamento eliminado',
  },
};
